import React, { useEffect, useState } from "react";
import { api, formatDateBR } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../components/ui/dialog";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "../hooks/use-toast";

export default function Simulados() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", date: new Date().toISOString().split("T")[0], total_questions: 0, correct: 0, wrong: 0, duration_minutes: 0 });

  const load = async () => { const r = await api.get("/simulados"); setItems(r.data); };
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!form.name) { toast({ title: "Informe o nome do simulado" }); return; }
    await api.post("/simulados", {
      ...form,
      total_questions: Number(form.total_questions),
      correct: Number(form.correct),
      wrong: Number(form.wrong),
      duration_minutes: Number(form.duration_minutes),
    });
    setOpen(false);
    setForm({ name: "", date: new Date().toISOString().split("T")[0], total_questions: 0, correct: 0, wrong: 0, duration_minutes: 0 });
    load();
  };

  const del = async (id) => { await api.delete(`/simulados/${id}`); load(); };

  return (
    <div className="space-y-6 max-w-[1400px]">
      <div className="flex items-center justify-between">
        <h1 className="font-display text-3xl font-extrabold">Simulados</h1>
        <Button onClick={() => setOpen(true)} className="bg-tiffany-500 hover:bg-tiffany-600 text-white">
          <Plus size={16} className="mr-1" /> Novo Simulado
        </Button>
      </div>

      {items.length === 0 ? (
        <div className="rounded-2xl border border-dashed border-border p-12 text-center text-muted-foreground">
          Nenhum simulado registrado.
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((m) => {
            const pct = m.total_questions ? Math.round((m.correct / m.total_questions) * 100) : 0;
            return (
              <div key={m.id} className="rounded-2xl bg-card border border-border p-5">
                <div className="flex justify-between items-start mb-3">
                  <div>
                    <h3 className="font-display font-bold">{m.name}</h3>
                    <p className="text-xs text-muted-foreground">{formatDateBR(m.date)}</p>
                  </div>
                  <button onClick={() => del(m.id)} className="text-red-500 hover:bg-red-50 p-1.5 rounded"><Trash2 size={14} /></button>
                </div>
                <div className="grid grid-cols-2 gap-2 text-sm mb-3">
                  <div><span className="text-muted-foreground">Acertos:</span> <span className="font-semibold text-green-600">{m.correct}</span></div>
                  <div><span className="text-muted-foreground">Erros:</span> <span className="font-semibold text-red-500">{m.wrong}</span></div>
                  <div><span className="text-muted-foreground">Total:</span> <span className="font-semibold">{m.total_questions}</span></div>
                  <div><span className="text-muted-foreground">Tempo:</span> <span className="font-semibold">{m.duration_minutes} min</span></div>
                </div>
                <div className="pt-3 border-t border-border flex justify-between items-center">
                  <span className="text-sm text-muted-foreground">Aproveitamento</span>
                  <span className={`font-bold text-lg ${pct >= 70 ? "text-green-600" : pct >= 50 ? "text-yellow-600" : "text-red-500"}`}>{pct}%</span>
                </div>
              </div>
            );
          })}
        </div>
      )}

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader><DialogTitle>Novo Simulado</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <Input placeholder="Nome (ex: Simulado PCDF 01)" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
            <Input type="date" value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} />
            <div className="grid grid-cols-2 gap-2">
              <div>
                <label className="text-xs">Total questões</label>
                <Input type="number" value={form.total_questions} onChange={(e) => setForm({ ...form, total_questions: e.target.value })} />
              </div>
              <div>
                <label className="text-xs">Duração (min)</label>
                <Input type="number" value={form.duration_minutes} onChange={(e) => setForm({ ...form, duration_minutes: e.target.value })} />
              </div>
              <div>
                <label className="text-xs">Acertos</label>
                <Input type="number" value={form.correct} onChange={(e) => setForm({ ...form, correct: e.target.value })} />
              </div>
              <div>
                <label className="text-xs">Erros</label>
                <Input type="number" value={form.wrong} onChange={(e) => setForm({ ...form, wrong: e.target.value })} />
              </div>
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>Cancelar</Button>
            <Button onClick={save} className="bg-tiffany-500 hover:bg-tiffany-600 text-white">Salvar</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
